import React from 'react'

import { AnalyticsDataLabel } from '../AnalyticsDataLabel/AnalyticsDataLabel'
import { analyticsSocialPlatformLabelIcons } from './AnalyticsSocialPlatformLabel.consts'
import type { AnalyticsSocialPlatformLabelType } from './AnalyticsSocialPlatformLabel.types'

type AnalyticsSocialPlatformLabelProps = {
  type: AnalyticsSocialPlatformLabelType
}

export const AnalyticsSocialPlatformLabel = ({ type }: AnalyticsSocialPlatformLabelProps) => {
  return (
    <AnalyticsDataLabel
      label={type}
      icon={{
        src: analyticsSocialPlatformLabelIcons[type],
        width: 20,
      }}
    />
  )
}
